export default {
    CORE_API: process.env.VUE_APP_CORE_API,
    CLUB_API: process.env.VUE_APP_CLUB_API,
    CLUB_CLIENT: process.env.VUE_APP_CLUB_CLIENT,
    CLUB_SECRET: process.env.VUE_APP_CLUB_SECRET
};
